import React from 'react';
import { Container, Card } from 'react-bootstrap';

const ConsentPersonalData = () => (
  <Container className="mt-4 mb-4">
    <Card>
      <Card.Body>
        <Card.Title className="mb-4">Согласие на обработку персональных данных</Card.Title>
        <style>{`
          .consent-list {
            margin-left: 18px;
            padding-left: 18px;
            word-break: break-word;
            overflow-wrap: anywhere;
          }
          .consent-list li {
            margin-bottom: 8px;
            line-height: 1.6;
          }
          @media (max-width: 700px) {
            .consent-list {
              margin-left: 8px;
              padding-left: 8px;
            }
          }
        `}</style>
        <div style={{whiteSpace: 'pre-line', fontSize: '1.1rem', lineHeight: 1.7}}>
          <div style={{marginBottom: 24}}>
            1. Настоящее согласие на обработку персональных данных (далее по тексту Согласие), выражает волю пользователя информационно-телекоммуникационной сети «Интернет», (далее по тексту Покупатель) передающего свои персональные данные через сайт расположенном по адресу https://karuseli59.ru/ (далее по тексту Сайт) ИП Ситдикова Г.А., ОГРНИП 321595800054069, ИНН 590800286952 (далее по тексту Оператор).
          </div>
          <div style={{marginBottom: 24}}>
            2. В соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» Покупатель дает разрешение на обработку, в том числе автоматизированную, своих персональных данных, указываемых в заказе и/или ином разделе на Интернет-ресурс Продавца, в соответствии с Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных», включая сбор, систематизацию, накопление, хранение, уточнение (обновление, изменение), использование с целью приобретения товара, информирования Покупателя о совершённых и совершаемых покупках. Согласие на обработку персональных данных дано без ограничения срока действия.
          </div>
          <div style={{marginBottom: 24}}>
            3. Покупатель дает Исполнителю согласие на обработку следующих персональных данных:
            <ul className="consent-list">
              <li>фамилия, имя, отчество;</li>
              <li>адрес электронной почты;</li>
              <li>сведения, собираемые посредством метрических программ.</li>
            </ul>
          </div>
          <div style={{marginBottom: 24}}>
            4. Покупатель разрешает Исполнителю производить автоматизированную, а также осуществляемую без использования средств автоматизации обработку персональных данных, в том числе:
            <ul className="consent-list">
              <li>сбор;</li>
              <li>запись;</li>
              <li>систематизацию;</li>
              <li>накопление;</li>
              <li>хранение;</li>
              <li>уточнение (обновление, изменение);</li>
              <li>извлечение;</li>
              <li>использование;</li>
              <li>блокирование;</li>
              <li>удаление;</li>
              <li>уничтожение.</li>
            </ul>
          </div>
          <div style={{marginBottom: 24}}>
            5. Согласие действует с даты его предоставления, до момента достижения цели обработки персональных данных. Покупатель вправе отозвать Согласие на обработку персональных данных, письменно уведомив об этом Оператора.
          </div>
        </div>
      </Card.Body>
    </Card>
  </Container>
);

export default ConsentPersonalData; 